module.exports = __webpack_public_path__ + "img/presentation.c972451a.webp";